module.exports = __webpack_public_path__ + "static/img/weather.a0705d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/weather.svg
// module id = GKSq
// module chunks = 0